import React, { Component } from 'react';
import { NetlifyForm } from '../containers/netlify-form';
import FormGroup from '../components/Form/FormGroup';
import { ButtonPrimary } from '../components/Button';
import Label from '../components/Form/Label';
import Input from '../components/Form/Input';
import TextArea from '../components/TextArea';

export const ContactForm = () => {
  return (
    <NetlifyForm
      action="/thanks/"
      name="contact-form"
    >
      <div className="flex flex-col md:flex-row justify-center">
        <div className="w-full md:w-1/2 px-4 mx-auto  mb-4 md:mb-0">
          <FormGroup
            label={<Label htmlFor="contact-name">Name</Label>}
            input={
              <Input
                id="contact-name"
                name="name"
                pattern=".*"
                required
              />
            }
          />
          <FormGroup
            label={<Label htmlFor="contact-company">Company</Label>}
            input={
              <Input
                id="contact-company"
                name="company"
                required
              />
            }
          />
          <FormGroup
            label={<Label htmlFor="contact-phone">Phone</Label>}
            input={
              <Input
                id="contact-phone"
                name="phone"
              />
            }
          />
          <FormGroup
            label={<Label htmlFor="contact-email">Email</Label>}
            input={
              <Input
                id="contact-email"
                name="email"
                type="email"
                required
              />
            }
          />
        </div>
        <div className="w-full md:w-1/2 px-4 mx-auto flex-0 md:flex-1 flex flex-col">
          <FormGroup
            className="flex-1 flex flex-col w-full"
            label={
              <Label htmlFor="contact-message">Introduce Yourself</Label>
            }
            input={
              <TextArea
                id="contact-message"
                name="message"
                className="flex-1"
              />
            }
          />
          <ButtonPrimary
            type="submit"
            className="w-full"
          >
            Send
          </ButtonPrimary>
        </div>
      </div>
    </NetlifyForm>
  );
};



// WEBPACK FOOTER //
// ./src/forms/ContactForm.js